<template>
  <div class="detail create">
    <div class="screen">
      <div class="banner">
        <mt-field
          readonly
          label="表单编号"
          v-model="detail.businessKey"
        ></mt-field>
      </div>
    </div>
    <div class="center">
      <applicant-info
        :editable="false"
        :costName="detail.costCenterName"
        :lineName="detail.businessLineName"
        :applicant="detail.applicantName"
        :createUserName="detail.submiterName"
        :createDate="detail.applicationDateStr"
      ></applicant-info>
      <div
        v-if="detail.currentRole == 2 || detail.currentRole == 3"
        class="a_infor"
        :class="{ open: isOpen }"
      >
        <p @click="isOpen = !isOpen">{{ title }}</p>
        <div class="box">
          <mt-radio
            title="协议类型："
            v-model="request.protocolType"
            :options="TypeOptions"
          ></mt-radio>
          <mt-radio
            title="签订类型："
            v-model="request.signType"
            :options="SignedOptions"
          ></mt-radio>

          <mt-field
            readonly
            label="合同开始日期"
            placeholder="请选择开始日期"
            v-model="request.startDate"
            @click.native="ShowPicker(1)"
          ></mt-field>
          <mt-field
            readonly
            label="合同结束日期"
            placeholder="请选择结束日期"
            v-model="request.endDate"
            @click.native="ShowPicker(2)"
          ></mt-field>

          <p>合同信息（项目名称）</p>
          <mt-field
            placeholder="合同信息（项目名称），最多50个字"
            v-model="request.info"
            :attr="{ maxlength: 50 }"
            type="textarea"
            rows="1"
          ></mt-field>
          <p>合同内容</p>
          <mt-field
            placeholder="描述合同的内容及签订的原因或变化的原因，最多300个字"
            :attr="{ maxlength: 300 }"
            v-model="request.contractContent"
            type="textarea"
            rows="3"
          ></mt-field>
          <mt-radio
            v-if="request.signType != '10'" 
            title="当前合同金额类型："
            v-model="request.curContractType"
            :options="amountType"
          ></mt-radio>
          <mt-field
            v-if="request.signType != '10' && request.curContractType == 10"
            label="当前合同金额"
            v-model="request.currentAmount"
            placeholder="请输入当前合同金额"
            type="number"
          >元</mt-field>  
          <mt-field
            v-if="request.signType != '10' && request.curContractType == 20"
            label="当前合同金额"
            v-model="request.currentAmount"
            placeholder="请输入当前合同金额"
          ></mt-field> 
          <mt-radio
            title="新合同金额类型："
            v-model="request.newContractType"
            :options="amountType"
          ></mt-radio>
          <mt-field
            v-if="request.newContractType == 10"
            label="新合同金额"
            v-model="request.newAmount"
            placeholder="请输入新合同金额"
            type="number"
          >元</mt-field>
          <mt-field
            v-if="request.newContractType == 20"
            label="新合同金额"
            v-model="request.newAmount"
            placeholder="请输入新合同金额"
          ></mt-field>
          <!-- 供应链合同特有字段 -->
          <mt-radio
            v-if="request.signType != '10'"
            title="当前付款周期"
            v-model="request.currentPaymentTerms"
            :options="PaymentOptions"
          ></mt-radio>
          <mt-field
            v-if="
              request.signType != '10' && request.currentPaymentTerms == '30'
            "
            placeholder="请输入当前付款周期"
            v-model="request.currentPaymentTermsOther"
            :attr="{ maxlength: 20 }"
          ></mt-field>
          <mt-radio
            title="新付款周期"
            v-model="request.newPaymentTerms"
            :options="PaymentOptions"
          ></mt-radio>
          <mt-field
            v-if="request.newPaymentTerms == '30'"
            placeholder="请输入新付款周期"
            v-model="request.newPaymentTermsOther"
            :attr="{ maxlength: 20 }"
          ></mt-field>
          <mt-radio
            v-if="request.signType == '10'"
            title="是否添加到SCM系统(仅限新合同填写)"
            style="justify-content: center"
            v-model="request.addSCMStr"
            :options="AddSCMOptions"
          ></mt-radio>
          <mt-field
            v-if="currentApproverStr"
            readonly
            label="当前处理人"
            v-model="currentApproverStr"
          ></mt-field>
          <p>备注</p>
          <mt-field
            style="padding-bottom: 20px"
            placeholder="请输入备注信息"
            :attr="{ maxlength: 300 }"
            v-model="request.remark"
            type="textarea"
            rows="3"
          ></mt-field>
        </div>
        <mt-datetime-picker
          @touchmove.native.stop.prevent
          v-model="defaultStartDate"
          ref="picker1"
          type="date"
          :startDate="new Date('2010-01-01')"
          :endDate="new Date('2077-12-31')"
          year-format="{value}年"
          month-format="{value}月"
          date-format="{value}日"
          @confirm="handleConfirm1"
        ></mt-datetime-picker>
        <mt-datetime-picker
          @touchmove.native.stop.prevent
          ref="picker2"
          type="date"
          :startDate="defaultStartDate"
          :endDate="new Date('2077-12-31')"
          year-format="{value}年"
          month-format="{value}月"
          date-format="{value}日"
          @confirm="handleConfirm2"
        ></mt-datetime-picker>
      </div>
      <attach-upload
        :canUpload="true"
        :deletable="true"
        :maxLength="10"
        :value="request.attachmentList"
        :contractList="detail.contractList"
        :attachFileList="detail.attachFileList"
        :legalList="detail.legalList"
        :coeList="detail.coeList"
        :contractType="request.contractType"
      ></attach-upload>

      <div class="a_infor" :class="{ open: approveOpen }">
        <p @click="approveOpen = !approveOpen" class="red">备注</p>
        <div class="box" style="padding-bottom: 20px; margin-top: 10px">
          <mt-field
            placeholder="请输入..."
            v-model="approveRequest.approveRemark"
            :attr="{ maxlength: 200 }"
            type="textarea"
            rows="3"
          ></mt-field>
          <ul class="buttons">
            <li>
              <mt-button type="default" @click="ConfirmEdit()">更新</mt-button>
            </li>
            <li>
              <mt-button type="default" @click="GoBack()">返回</mt-button>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </div>
      <operation-log :list="detail.contractOperationLog"></operation-log>
    </div>
  </div>
</template>
    
    <script>
import ApplicantInfo from "@/components/ApplicantInfo.vue";
import AttachUpload from "@/components/zn_AttachUpload.vue";
import ContractInfo from "@/components/zn_ContractInfo.vue";
import OperationLog from "@/components/OperationLog.vue";
import { Toast, Indicator, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      currentApproverStr: "",
      isOpen: true,
      detail: {
        currentRole: 0,
        contractList: [],
        attachFileList: [],
        legalList: [],
        coeList: [],
        contractAttachment: [],
        contractOperationLog: [],
      },
      approveOpen: true,
      defaultStartDate: new Date(),
      isSubmmit: false,
      title: "",
      request: {
        approveRemark: "",
        applicantNo: "",
        applicantName: "",
        contractType: "",
        protocolType: "",
        approvalType: "",
        signType: "",
        startDate: "",
        endDate: "",
        info: "",
        contractContent: "",
        curContractType:0,
        currentAmount: "",
        newContractType:0,
        newAmount: "",
        currentPurchasingRebates: "",
        newPurchasingRebates: "",
        currentTaxRate: "",
        newTaxRate: "",
        currentPaymentTerms: "",
        currentPaymentTermsOther: "",
        newPaymentTerms: "",
        newPaymentTermsOther: "",
        addSCM: false,
        addSCMStr: "1",
        remark: "",
        isDraft: true,
        attachmentList: [],
        fiscalYear: "",
        quarter: "",
        district: "",
        serviceType: "",
        incrementTypeCode: "",
        incrementTypeDesc: "",
        sealType: "",
      },
      approveRequest: {
        isArchive: false,
        isApprove: false,
        approveRemark: "",
        isJumpToLastTask: false,
      },
      amountType:[
        {
          label: "固定金额",
          value: "10",
        },
        {
          label: "其他",
          value: "20",
        }        
      ],
      TypeOptions: [
        {
          label: "服务协议(收入)",
          value: "10",
        },
        {
          label: "采购协议(支出)",
          value: "20",
        },
      ],
      ApproveOptions: [
        {
          label: "工商业、医疗供应链合同(分包)",
          value: "10",
        },
        {
          label: "工商业、医疗供应链合同(物料/分包)",
          value: "20",
        },
        {
          label: "配餐供应链合同",
          value: "30",
        },
      ],
      DisabledSignedOptions: [
        {
          label: "新合同",
          value: "10",
          disabled: true,
        },
        {
          label: "续签合同",
          value: "20",
          disabled: true,
        },
        {
          label: "补充协议",
          value: "30",
          disabled: true,
        },
      ],
      SignedOptions: [
        {
          label: "新合同",
          value: "10",
        },
        {
          label: "续签合同",
          value: "20",
        },
        {
          label: "补充协议",
          value: "30",
        },
      ],
      PaymentOptions: [
        {
          label: "月付",
          value: "10",
        },
        {
          label: "季付",
          value: "20",
        },
        {
          label: "其他",
          value: "30",
        },
      ],
      AddSCMOptions: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      incrementList: [
        {
          values: [],
        },
      ],
      incrementName: "请选择",
      tempSelectItem: [null, null],
      popupVisible: false,
      popupSealTypeVisible: false,
      sealTypeList: [
        {
          values: [
            {
              label: "总公司",
              value: "10",
            },
            {
              label: "分公司",
              value: "20",
            },
          ],
        },
      ],
      sealTypeName: "请选择",
      tempSealTypeSelectItem: [null, null],
    };
  },
  computed: {
    contractPeriod: {
      get: function () {
        var that = this;
        var result = "自动计算";
        if (
          that.request.startDate == null ||
          that.request.startDate == "" ||
          that.request.endDate == null ||
          that.request.endDate == ""
        ) {
          return result;
        } else {
          var startDate = new Date(that.request.startDate);
          var endDate = new Date(that.request.endDate);

          var year = endDate.getFullYear() - startDate.getFullYear();
          var month = endDate.getMonth() - startDate.getMonth();
          var day = endDate.getDate() - startDate.getDate();

          result = year * 12 + month;
          if (day >= 25) {
            result = result + 1;
          } else if (day >= 14 && day < 25) {
            result = result + 0.5;
          } else if (day <= -14 && day >= -25) {
            result = result - 0.5;
          } else if (day <= -25) {
            result = result - 1;
          }
          return result;
        }
      },
      set: function (newValue) {},
    },
  },
  components: {
    "applicant-info": ApplicantInfo,
    "attach-upload": AttachUpload,
    "contract-info": ContractInfo,
    "operation-log": OperationLog,
  },
  methods: {
    ConfirmEdit() {
      var that = this;
      MessageBox.confirm("", {
        title: "提示",
        message: "确定要提交更新吗?",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then((action) => {
          that.Edit();
        })
        .catch((error) => {
          return;
        });
    },
    Edit() {
      var that = this;
      if (that.request.addSCMStr == "1") {
        that.request.addSCM = true;
      } else {
        that.request.addSCM = false;
      }
      if (!that.request.startDate) {
        Toast("请选择合同起始日期");
        return;
      }
      if (!that.request.endDate) {
        Toast("请选择合同结束日期");
        return;
      }
      if (!that.request.info) {
        Toast("请填写合同信息");
        return;
      }
      if (!that.request.contractContent) {
        Toast("请填写合同内容");
        return;
      }
      if (that.request.contractType == 3) {
        if (!that.request.approvalType) {
          Toast("请选择审批类型");
          return;
        }
      } else {
        if (!that.request.protocolType) {
          Toast("请选择协议类型");
          return;
        }
      }
      if (!that.request.signType) {
        Toast("请选择签订类型");
        return;
      }    
      if (
        !that.request.attachmentList ||
        that.request.attachmentList.length == 0
      ) {
        Toast("请上传合同附件");
        return;
      } else {
        var isHaveContractAttach = false;
        var isHaveLegal = false;
        var isHaveCOE = false;
        that.request.attachmentList.forEach((item) => {
          if (item.type == 1) {
            isHaveContractAttach = true;
          }
          if (item.type == 3) {
            isHaveLegal = true;
          }
          if (item.type == 4) {
            isHaveCOE = true;
          }
        });
        if (!isHaveContractAttach) {
          Toast("请上传合同附件");
          return;
        }
        if (
          (that.request.contractType == 5 ||
            that.request.contractType == 6 ||
            that.request.contractType == 7) &&
          !isHaveLegal
        ) {
          Toast("请上传法务邮件审批截图");
          return;
        }
        if (
          (that.request.contractType == 5 ||
            that.request.contractType == 6 ||
            that.request.contractType == 7) &&
          !isHaveCOE
        ) {
          Toast("请上传OpX邮件审批截图");
          return;
        }
      }
      
      that.request.editRemark = that.approveRequest.approveRemark;
      if (that.isSubmmit) {
        return;
      }
      Indicator.open("提交中");
      that.isSubmmit = true;
      that.$axios
        .post("/api/Contract/LegalEditContract", that.request)
        .then((res) => {
          Indicator.close();
          that.isSubmmit = false;
          if (res.data != null && res.data.isSuccess) {
            MessageBox.alert("提交成功").then((action) => {
              that.$router.go(-1);
            });
          } else {
            Toast({
              message: res.data.message,
              duration: 4000,
            });
          }
        })
        .catch((err) => {
          Indicator.close();
          that.isSubmmit = false;
          Toast("提交失败，请联系管理员");
          console.log(err);
        });
    },
    GoBack() {
      var that = this;
      MessageBox.confirm("", {
        title: "提示",
        message: "确定要返回上一页吗?",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then((action) => {
          that.$router.go(-1);
        })
        .catch((error) => {
          return;
        });
    },
    getDateStr(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var month = (d.getMonth() + 1).toString();
      if (month.length == 1) {
        month = "0" + month;
      }
      var day = d.getDate().toString();
      if (day.length == 1) {
        day = "0" + day;
      }
      var hour = d.getHours().toString();
      if (hour.length == 1) {
        hour = "0" + hour;
      }
      var minute = d.getMinutes().toString();
      if (minute.length == 1) {
        minute = "0" + minute;
      }
      return `${year}-${month}-${day}`;
    },
    handleConfirm1(value) {
      var that = this;
      that.request.startDate = that.getDateStr(value);
    },
    handleConfirm2(value) {
      var that = this;
      that.request.endDate = that.getDateStr(value);
    },
    ShowPicker(index) {
      var that = this;
      if (index == 1) {
        that.$refs.picker1.open();
      } else {
        that.$refs.picker2.open();
      }
    },
    loadDetail() {
      var that = this;
      Indicator.open("数据加载中");
      that.$axios
        .get(
          `/api/Contract/GetDetail?businessKey=${that.request.businessKey}&type=${that.request.contractType}&taskId=${that.request.taskId}`
        )
        .then((res) => {
          Indicator.close();
          var result = res.data;
          if (result != null && result.isSuccess) {
            that.detail = result.data;
            if (that.detail.currentRole != 2 && that.detail.currentRole != 3) {
              that.$router.push({
                path: `/approve?businessKey=${that.request.businessKey}&type=${that.request.contractType}&taskId=${that.request.taskId}`,
              });
              return;
            }
            that.detail.contractList = [];
            that.detail.attachFileList = [];
            that.detail.legalList = [];
            that.detail.coeList = [];
            that.detail.contractAttachment.forEach((item) => {
              if (item.type == 1) {
                that.detail.contractList.push(item);
              } else if (item.type == 2) {
                that.detail.attachFileList.push(item);
              } else if (item.type == 3) {
                that.detail.legalList.push(item);
              } else if (item.type == 4) {
                that.detail.coeList.push(item);
              }
            });
            that.request.protocolType = result.data.protocolType + "";
            that.request.approvalType = result.data.approvalType + "";
            that.request.signType = result.data.signType + "";
            that.request.startDate = result.data.startDateStr;
            that.request.endDate = result.data.endDateStr;
            that.request.info = result.data.info;
            that.request.contractContent = result.data.contractContent;
            that.request.curContractType = result.data.curContractType;
            that.request.currentAmount = result.data.currentAmount;
            that.request.newContractType = result.data.newContractType;
            that.request.newAmount = result.data.newAmount;
            that.request.currentPurchasingRebates =
              result.data.currentPurchasingRebates;
            that.request.newPurchasingRebates =
              result.data.newPurchasingRebates;
            that.request.currentTaxRate = result.data.currentTaxRate;
            that.request.newTaxRate = result.data.newTaxRate;
            that.request.currentPaymentTerms =
              result.data.currentPaymentTerms + "";
            that.request.currentPaymentTermsOther =
              result.data.currentPaymentTermsOther;
            that.request.newPaymentTerms = result.data.newPaymentTerms + "";
            that.request.newPaymentTermsOther =
              result.data.newPaymentTermsOther;
            that.request.addSCM = result.data.addSCM;
            that.request.addSCMStr = result.data.addSCM ? "1" : "0";
            that.request.remark = result.data.remark;
            that.request.attachmentList = result.data.contractAttachment;
            that.request.fiscalYear = result.data.fiscalYear;
            that.request.quarter = result.data.quarter;
            that.request.district = result.data.district;
            that.request.serviceType = result.data.serviceType;
            that.request.incrementTypeCode = result.data.incrementTypeCode;
            that.request.incrementTypeDesc = result.data.incrementTypeDesc;
            that.incrementName = that.request.incrementTypeDesc;

            if (result.data.sealType == "10") {
              that.request.sealType = "10";
              that.sealTypeName = "总公司";
            } else {
              that.request.sealType = "20";
              that.sealTypeName = "分公司";
            }

            that.currentApproverStr = "";
            if (result.data.currentApprover) {
              var jsonObj = JSON.parse(result.data.currentApprover);
              if (jsonObj && jsonObj.constructor == Array) {
                jsonObj.forEach((item) => {
                  that.currentApproverStr += item.UserName;
                });
              } else if (jsonObj && jsonObj.constructor == Object) {
                if (jsonObj.UserName) {
                  that.currentApproverStr = jsonObj.UserName;
                }
              }
            }
          } else {
            Toast(result.message);
          }
        })
        .catch((err) => {
          Indicator.close();
          Toast("数据加载失败，请稍后再试");
          console.log(err);
        });
    },
    onValuesChange(picker, values) {
      var that = this;
      if (values && values[0]) {
        that.tempSelectItem[0] = values[0];
      }
    },
    confirmSelect() {
      var that = this;
      that.popupVisible = false;
      that.request.incrementTypeCode = that.tempSelectItem[0].classItem;
      that.request.incrementTypeDesc = that.tempSelectItem[0].className;
      that.incrementName = that.request.incrementTypeDesc;
    },
    ShouPup() {
      var that = this;
      that.popupVisible = true;
    },
    GetIncrementType() {
      var that = this;
      that.$axios
        .get(`/api/Common/GetAllIncrementType?code=Contract_IncrementType`)
        .then((res) => {
          if (res.data != null && res.data.isSuccess) {
            if (res.data.data) {
              res.data.data.forEach((item) => {
                that.incrementList[0].values.push(item);
              });
            }
          }
        })
        .catch((err) => {
          Toast("查询失败");
          console.log(err);
        });
    },
    ShouPupSealType() {
      var that = this;
      that.popupSealTypeVisible = true;
    },
    onSealTypeValuesChange(picker, values) {
      var that = this;
      if (values && values[0]) {
        that.tempSealTypeSelectItem[0] = values[0];
      }
    },
    confirmSealTypeSelect() {
      var that = this;
      that.popupSealTypeVisible = false;
      that.request.sealType = that.tempSealTypeSelectItem[0].value;
      that.sealTypeName = that.tempSealTypeSelectItem[0].label;
    },
  },
  created() {
    var that = this;
    that.request.contractType = "2";
    that.request.businessKey = that.$route.query.businessKey;
    that.request.taskId = that.$route.query.taskId;

    that.approveRequest.contractType = "2";
    that.approveRequest.businessKey = that.$route.query.businessKey;
    that.approveRequest.taskId = that.$route.query.taskId;

    that.title = "职能合同信息";

    that.GetIncrementType();
    that.loadDetail();
  },
  mounted() {
    var that = this;
  },
};
</script>
    